window.googleMapsLoadedCallback;
window.initGoogleMaps = function () {
    if (googleMapsLoadedCallback) {
        googleMapsLoadedCallback();
    }
}

window.prevPlacesResult = [];

window.sortByRelevance = function (array, key) {

    if (!array) return;

    for (var i in array) {
        array[i].original_order = i;
    }

    key = key || "";

    array.sort(function (obj1, obj2) {
        var marks1 = 0;
        var marks2 = 0;

        var containsKeyword1 = (key.length > 1) && (obj1.name.toLowerCase().indexOf(key)) > -1;
        var containsKeyword2 = (key.length > 1) && (obj2.name.toLowerCase().indexOf(key)) > -1;

        var inUS1 = (obj1.formatted_address.toLowerCase().indexOf("united states")) > -1;
        var inUS2 = (obj2.formatted_address.toLowerCase().indexOf("united states")) > -1;

        if (containsKeyword1) {
            marks1 += 4;
        }

        if (containsKeyword2) {
            marks2 += 4;
        }

        if (containsKeyword1 && containsKeyword2) {
            if (obj1.name.length < obj2.name.length) {
                marks1 += 1;
            }

            if (obj2.name.length < obj1.name.length) {
                marks2 += 1;
            }
        }

        if (obj1.original_order < obj2.original_order) {
            marks1 += 1;
        }
        else {
            marks2 += 1;
        }

        if (inUS1) {
            marks1 += 4;
        }

        if (inUS2) {
            marks2 += 4;
        }


        obj1.marks = marks1;
        obj2.marks = marks2;

        if (marks1 > marks2) return -1;
        if (marks2 > marks1) return 1;
        return 0;

    });
}
const DEFAULT_FENCE_COLOR = '#4A90E2';

angular.module('harriApp')
    .factory('googleMaps', ["$rootScope", "$log", "$http", "$q", "httpHelper", "autoCompleteListTemplate", "$timeout", "hUser", "hEvent", "localize",
        function ($rootScope, $log, $http, $q, httpHelper, autoCompleteListTemplate, $timeout, hUser, hEvent, localize) {
        var googleMaps = {
            //the script should be loaded one time, and this flag is used to track that.
            inited: false,
            servicesInited: false,
            loaded: false,
            queueOfServicesCallsBeforeLoading: [], //a queue of callbacks to be calls after Google Maps get loaded
            html_attributions_object: null,
            service: null,
            geocoder: null,
            libraries: ['places'],
            markerIcon: '../images/marker.png',
            map: null,
            mapElement: "",
            marker: null,
            infowindow: null,
            infobox: null,
            fullScreenMap: false,
            location: null,
            locationCantBeFound: false,
            radius: 1000, // Killometers
            activeTheme: null,
            markerCluster: null,
            style: {
                'harri_blue': [
                    {
                        "stylers": [
                            {"hue": "#0088DD"},
                            {"saturation": 72},
                            {"gamma": 2.15},
                            {"lightness": -9}
                        ]
                    }
                ],
                'default': []
            },
            updateLocation: function () {
                var defer = $q.defer();

                var p = hUser.getUserLocation();
                p.then(function (data) {
                    googleMaps.locationCantBeFound = false;

                    googleMaps.location = {};
                    googleMaps.location.latitude = data.latitude;
                    googleMaps.location.longitude = data.longitude;

                }, function () {
                    googleMaps.locationCantBeFound = true;

                });

                p.then(function(r) {
                    defer.resolve(r);
                }, function(r) {
                    defer.resolve(r);
                });

                return defer.promise;
            },

            init: function () {
                if (googleMaps.inited) return;

                googleMaps.inited = true;

                window.googleMapsLoadedCallback = googleMaps.loadedCallback;

                var lang = localize.getLang();
                $.getScript('https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=' + googleMaps.libraries.join(',') + "&callback=initGoogleMaps&key=" + publicConfiguration.keys.google.services + "&language=" + lang);
            },

            loadedCallback: function () {
                googleMaps.loaded = true;

                if (!googleMaps.servicesInited) {
                    googleMaps.initServices();
                }

                googleMaps.service = new google.maps.places.PlacesService(googleMaps.html_attributions_object.get(0));
                googleMaps.autoCompleteService = new google.maps.places.AutocompleteService();
                googleMaps.geocoder = new google.maps.Geocoder();

                var callbackArray;
                while ((callbackArray = googleMaps.queueOfServicesCallsBeforeLoading.pop()) != null) {
                    callbackArray[0](callbackArray[1], callbackArray[2]);
                }

                // $.getScript('//raw.githubusercontent.com/printercu/google-maps-utility-library-v3-read-only/master/infobox/src/infobox_packed.js', function() {});
                $.getScript('../modules/forms/scripts/infobox_packed.js');


            },

            initServices: function () {
                if (!googleMaps.inited) {
                    googleMaps.init();
                }

                if (!googleMaps.html_attributions_object) {
                    googleMaps.html_attributions_object = $("<div>").hide();
                    $('body').append(googleMaps.html_attributions_object);
                }

                googleMaps.servicesInited = true;
            },

            googleServicePromise: function (defer) {
                if (defer) {

                    defer.resolve();
                    return defer.promise;

                } else if (!defer) {
                    defer = $q.defer();
                }

                if (!googleMaps.servicesInited) {
                    googleMaps.initServices();
                }

                if (!googleMaps.loaded) {
                    googleMaps.queueOfServicesCallsBeforeLoading.push([googleMaps.googleServicePromise, defer])
                } else {
                    defer.resolve();
                }

                return defer.promise;
            },

            getAddressFromCoordinates: async (lat, lng, address, type , placeTypes = [`establishment`]) => {
                const deferred = $q.defer();
                let params = {
                    location: { lat: parseFloat(lat), lng: parseFloat(lng) }
                }
                googleMaps.geocoder.geocode(params, async (results, status) => {
                    if (status === 'OK') {
                        if (results.length > 0) {
                            let location;

                            for (let i in results) {
                                try {
                                    let locationLat = results[i].geometry.location.lat();
                                    let locationLng = results[i].geometry.location.lng();
                                    let formattedAddress = results[i].formatted_address;
                                    const isLatMatch = Math.abs(lat - locationLat) < 0.0001;
                                    const isLngMatch = Math.abs(lng - locationLng) < 0.0001;
                                    const isAddressMatch = address ? formattedAddress.toLowerCase() === address.toLowerCase() : true;

                                    if (isLatMatch && isLngMatch && isAddressMatch) {
                                        location = JSON.parse(JSON.stringify(results[i]));
                                        location.geometry.location.lat = locationLat;
                                        location.geometry.location.lng = locationLng;
                                        break;
                                    }
                                } catch (error) {
                                    console.error("Error processing result " + i + ": " + error.message);
                                }
                            }

                            if (location) {
                                let value = type === 'place'? location : { result: location };
                                let placeResults;
                                if (type === 'place') {
                                    placeResults = await googleMaps.placeAutocomplete(location.formatted_address , null , placeTypes);
                                }
                                let label = type === 'place' && placeResults?.length? placeResults[0].value.description : location.formatted_address;
                                deferred.resolve({
                                    label: label,
                                    value: value
                                });
                            } else {
                                deferred.reject('No matching results found');
                            }
                        } else {
                            deferred.reject('No results found');
                        }
                    } else {
                        deferred.reject('Geocoder failed due to: ' + status);
                    }
                });
                return deferred.promise;
            },

            getAddressDetails: async (lat, lng, address, type , placeTypes = [`establishment`]) => {
                const deferred = $q.defer();

                if (type === 'place' && address) {
                    let placeResults = await googleMaps.placeAutocomplete(address , null , placeTypes);
                    if (placeResults.length) {
                        let data = {placeId: placeResults[0].value.place_id};
                        googleMaps.getDetails(data, (res, status) => {
                            if (status === "OK") {
                                placeResults[0].value.geometry = res.geometry;
                                deferred.resolve({
                                    label: placeResults[0].value.description,
                                    value: placeResults[0].value,
                                });
                            } else {
                                deferred.reject('Geocoder failed due to: ' + status);
                            }
                        });
                    } else {
                        deferred.resolve(googleMaps.getAddressFromCoordinates(lat, lng, address, type, placeTypes));
                    }
                } else {
                    deferred.resolve(googleMaps.getAddressFromCoordinates(lat, lng, address, type, placeTypes));
                }

                return deferred.promise;
            },
            textSearch: function (request, callback) {
                if (!googleMaps.servicesInited) {
                    googleMaps.initServices();
                }

                if (!googleMaps.loaded) {
                    googleMaps.queueOfServicesCallsBeforeLoading.push([googleMaps.textSearch, request, callback]);
                } else {
                    //request = {query: "search String", types: ["restaurant", "food"]}
                    //callback = function(r, status="ok")
                    googleMaps.service.textSearch(request, callback);
                }
            },

            placeSearch: function (request, callback) {
                if (!googleMaps.servicesInited) {
                    googleMaps.initServices();
                }

                if (!googleMaps.loaded) {
                    googleMaps.queueOfServicesCallsBeforeLoading.push([googleMaps.placeSearch, request, callback]);
                } else {
                    //request = {query: "search String", types: ["restaurant", "food"]}
                    //callback = function(r, status="ok")
                    googleMaps.service.placeSearch(request, callback);
                }
            },

            nearbySearch: function (request, callback) {
                if (!googleMaps.servicesInited) {
                    googleMaps.initServices();
                }

                if (!googleMaps.loaded) {
                    googleMaps.queueOfServicesCallsBeforeLoading.push([googleMaps.nearbySearch, request, callback]);
                } else {
                    //request = {query: "search String", types: ["restaurant", "food"]}
                    //callback = function(r, status="ok")
                    googleMaps.service.nearbySearch(request, callback);
                }
            },

            getDetails: function (request, callback) {
                if (!googleMaps.servicesInited) {
                    googleMaps.initServices();
                }

                request = angular.copy(request);

                if (googleMaps.sessionToken) {
                    request['sessionToken'] = googleMaps.sessionToken;
                    delete googleMaps.sessionToken;
                }

                request['fields'] = [
                    "address_components",
                    "adr_address",
                    "formatted_address",
                    "geometry",
                    "icon",
                    "name",
                    "photos",
                    "place_id",
                    "plus_code",
                    "types",
                    "vicinity",
                    "url"

                    // "utc_offset",

                    /* Contact category + 0.003 USD per request */
                    // "formatted_phone_number",
                    // "opening_hours",
                    // "international_phone_number",
                    // "website"

                    /* Atmosphere category + 0.005 USD per request */
                    // "price_level"
                    // "rating",
                    // "reviews",
                ];

                if (!googleMaps.loaded) {
                    googleMaps.queueOfServicesCallsBeforeLoading.push([googleMaps.getDetails, request, function(res, status){

                        var location = JSON.parse(JSON.stringify(res));

                        try {
                            location.geometry.location.lat = res.geometry.location.lat();
                            location.geometry.location.lng = res.geometry.location.lng();
                        }
                        catch (e) {}

                        callback(location, status);
                    }]);
                } else {
                    //request = {placeId: "ChIJuakJu6VZwokR6UdaYNg7IKE"}
                    //callback = function(r, status="ok")
                    googleMaps.service.getDetails(request, function(res, status){
                        var location = JSON.parse(JSON.stringify(res));

                        try {
                            location.geometry.location.lat = res.geometry.location.lat();
                            location.geometry.location.lng = res.geometry.location.lng();
                        }
                        catch (e) {}

                        callback(location, status);
                    });
                }
            },

            foundBounds: function (locations) {
                var markers = locations;
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < markers.length; i++) {
                    bounds.extend(markers[i]);
                }
                googleMaps.map.fitBounds(bounds);
            },

            clusterMarkers: function (locations, clusterIconURL, singleIconUrl) {
                var markers = locations.map(function(position) {
                    var marker = new google.maps.Marker({
                        position: position,
                        icon: singleIconUrl
                    });
                    return marker;
                });

                var map = googleMaps.map;
                var markerClusterObj = {
                    map: map,
                    markers: markers,
                    renderer: {
                        render: function (renderObj) {
                            return new google.maps.Marker({
                                map: map,
                                label: {
                                    text: String(renderObj.count),
                                    fontWeight: "500",
                                },
                                position: renderObj.position,
                                icon: {
                                    url: clusterIconURL,
                                }
                            })
                        }
                    }
                };

                googleMaps.markerCluster = new markerClusterer.MarkerClusterer(markerClusterObj);
            },

            placeAutocomplete: function (place, nearByPlaces, types) {
                var defer = $q.defer();

                 if (nearByPlaces !== false) {
                    nearByPlaces = true;
                 }

                //google map loaded
                googleMaps.googleServicePromise().then(function () {

                  if (!place || place == '') {
                      defer.resolve([]);
                      return defer.promise;
                  }

                  googleMaps.updateLocation().then(function(){

                      googleMaps.sessionToken = googleMaps.sessionToken || new google.maps.places.AutocompleteSessionToken();

                      var autoCompleteRequest = {
                          input: place.trim(),
                          types: ['establishment'],
                          sessionToken: googleMaps.sessionToken
                      };

                      if (types && angular.isArray(types)) {
                          autoCompleteRequest['types'] = types;
                      }

                      if (nearByPlaces && googleMaps.location && googleMaps.location.latitude) {
                          autoCompleteRequest.location = new google.maps.LatLng(googleMaps.location.latitude, googleMaps.location.longitude);
                          autoCompleteRequest.radius = googleMaps.radius;
                      }

                      googleMaps.autoCompleteService
                          .getPlacePredictions(autoCompleteRequest, function (results, status) {

                              var autoCompleteResponse = [];

                              for (var i in results) {
                                  var autocompletePrediction = results[i];
                                  var structuredFormat = autocompletePrediction.structured_formatting || {};

                                  autoCompleteResponse.push({
                                      label: autoCompleteListTemplate({name: structuredFormat.main_text, address: structuredFormat.secondary_text}),
                                      value: autocompletePrediction
                                  });
                              }

                              defer.resolve(autoCompleteResponse);
                          });
                    });
                  });

                return defer.promise;
            },

            googlePlacesAutocomplete: function (location , searchGlobally = false) {

                var defer = $q.defer();

                const getQueryPredictions = (options) => {
                    return googleMaps.googleServicePromise().then(function () {
                        googleMaps.autoCompleteService
                            .getQueryPredictions(options,function (results, status) {
                                defer.resolve(results);
                            });
                    });
                };

                const searchOptions = {
                    'input': location,
                };

                if (searchGlobally) {
                    getQueryPredictions(searchOptions, function (results, status) {
                        defer.resolve(results);
                    });
                } else {
                    searchOptions.componentRestrictions = {
                        country: 'US'
                    };

                    hUser.getUserLocation().then((userLocation) => {

                        if (userLocation && userLocation.countryCode) {
                            if (userLocation.countryCode === 'US') {
                                searchOptions['input'] = 'US, ' + location;
                            }

                            if (userLocation.countryCode === 'IRL') {
                                searchOptions['componentRestrictions']['country'] = [`UK`, userLocation.countryCode];
                            } else {
                                searchOptions['componentRestrictions']['country'] = userLocation.countryCode;
                            }

                            getQueryPredictions(searchOptions);
                        }
                    });

                }

                return defer.promise;
            },

            locationAutocomplete: function (location) {
                var defer = $q.defer();

                var params = {};

                if (location) {

                    if (typeof(location) == 'object' && location.geometry) {
                        $timeout(function () {
                            defer.resolve([
                                {label: location.formatted_address, value: {result: location}}
                            ]);
                        }, 100);
                    } else {

                      //google map loaded
                      googleMaps.googleServicePromise().then(function () {
                        googleMaps.updateLocation().then(function(){

                          var locationParts = location.split(",");

                          if (locationParts.length == 2 && !isNaN(locationParts[0]) && !isNaN(locationParts[1])) {
                            // longitutde, latitude search, create new latlng object
                            params.location = new google.maps.LatLng(locationParts[0], locationParts[1]);;

                              // hEvent.track("geocode", { category: 'google_apis', label: 'autocomplete_1' });
                              googleMaps.geocoder.geocode(params, function(results, status) {
                                  var data = [];

                                  for (var i in results) {
                                      var location = results[i];
                                      data.push({label: location.formatted_address, value: {result: location}});
                                  }

                                  defer.resolve(data);
                              });
                          }
                          else {

                              hUser.getUserLocation().then(function (userLocation) {

                                  params.address = location;
                                  params.region = 'US';

                                  if (userLocation && userLocation.countryCode) {
                                      if (userLocation.countryCode == 'US') {
                                          params.address = 'US, ' + location;
                                      }

                                      params.region = userLocation.countryCode;
                                  }

                                  /** if (googleMaps.location) {
                                      var southWest = new google.maps.LatLng(googleMaps.location.latitude - 1, googleMaps.location.longitude - 1);
                                      var northEast = new google.maps.LatLng(googleMaps.location.latitude + 1, googleMaps.location.longitude + 1);
                                      params.bounds = new google.maps.LatLngBounds(southWest, northEast);
                                    } */

                                  // hEvent.track("geocode", { category: 'google_apis', label: 'autocomplete_2' });
                                  googleMaps.geocoder.geocode(params, function (results, status) {
                                      var data = [];

                                      for (var i in results) {
                                          var location = JSON.parse(JSON.stringify(results[i]));

                                          try {
                                              location.geometry.location.lat = results[i].geometry.location.lat();
                                              location.geometry.location.lng = results[i].geometry.location.lng();
                                          } catch (e) {
                                              console.log("couldn't find the following function = location.geometry.location.lng()", e);
                                          }

                                          data.push({label: location.formatted_address, value: {result: location}});
                                      }

                                      defer.resolve(data);
                                  });
                              });

                          }
                        });
                      });

                    }

                } else {
                    defer.resolve([]);
                }

                return defer.promise;
            },

            getAreaName: function (location) {

                var city = null;

                if (location) {
                    //find country name
                    for (var i = 0; i < location.address_components.length; i++) {
                        for (var b = 0; b < location.address_components[i].types.length; b++) {

                            //there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
                            if (location.address_components[i].types[b] == 'locality') {
                                //this is the object you are looking for
                                city = location.address_components[i];
                                break;
                            }
                        }
                    }
                }

                if (!city) {
                    city = {
                        'long_name': location.formatted_address
                    }
                }
                return city;

            },

            initMap: function (options, cp) {

                console.log("Here");
                if (!googleMaps.inited) {
                    googleMaps.init();
                }

                if (!googleMaps.loaded) {
                    googleMaps.queueOfServicesCallsBeforeLoading.push([googleMaps.initMap, options, cp]);
                } else {
                    googleMaps.mapElement = options.element;

                    var isRTL = localize.isRTL();
                    var fullscreenPosition = isRTL ? google.maps.ControlPosition.LEFT_TOP : google.maps.ControlPosition.RIGHT_TOP;
                    var zoomPosition = isRTL ? google.maps.ControlPosition.LEFT_BOTTOM : google.maps.ControlPosition.RIGHT_BOTTOM;
                    var DEFAULT_OPTIONS = {
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        activeTheme: options.activeTheme,
                        streetViewControl: false,
                        scrollwheel: options.scrollwheel || false,
                        zIndex: 1000,
                        // disableDefaultUI: true,
                        mapTypeControl: false,
                        scaleControl: true,
                        zoomControlOptions: {
                            position: zoomPosition
                        },
                        fullscreenControlOptions: {
                            position: fullscreenPosition
                        }
                    };

                    if (options.activeTheme) {
                        DEFAULT_OPTIONS.styles = googleMaps.activeTheme;
                    } else {
                        DEFAULT_OPTIONS.styles = googleMaps.style['harri_blue'];
                    }

                    googleMaps.markerIcon = options.markerIcon || googleMaps.markerIcon;

                    //options = $.extend(DEFAULT_OPTIONS, options);
                    googleMaps.map = new google.maps.Map(googleMaps.mapElement.get(0), options);

                    googleMaps.infowindow = new google.maps.InfoWindow({ pixelOffset: new google.maps.Size(100, 100) });

                    if (options.enableMarker) {
                        googleMaps.addMarkerWhenClick(options.markerChangedCallback);
                    }

                    if (options.enableViewPortChanged) {
                        googleMaps.viewPortChanged(options.viewPortChangedCallback);
                    }

                    if (cp) {
                        cp(googleMaps.map, googleMaps.infowindow);
                    }
                }
            },
            clearRadiusMarkerOnMap :()=> {
                if (googleMaps.circle) {
                    googleMaps.circle.setMap(null);
                    googleMaps.circle = null;
                }
            },
            addRadiusMarkerOnMap: (map, radius, locationCenter, options) => {
                let LatLng = new google.maps.LatLng(locationCenter.lat, locationCenter.lng);
                googleMaps.circle = new google.maps.Circle({
                    center: LatLng,
                    radius: radius, // in meters
                    map: map,
                    fillColor: options?.fillColor || DEFAULT_FENCE_COLOR,
                    fillOpacity: 0.3,
                    strokeColor: options?.strokeColor || DEFAULT_FENCE_COLOR,
                    strokeOpacity: 0.8,
                    strokeWeight: 1,
                });
            },

            changeDefaultMap: function (map) {
                googleMaps.map = map;
            },

            addMarkerWhenClick: function (callback) {
                googleMaps.map.addListener("click", function (e) {
                    googleMaps.placeMarkerAndPanTo(e.latLng, googleMaps.map);
                    if (callback) {
                        callback(e.latLng);
                    }
                });
            },

            viewPortChanged: function (callback) {
                googleMaps.map.addListener('idle', function() {
                    if (typeof googleMaps === 'object' && typeof googleMaps.map === 'object') {
                        var centerPoint = {lat: googleMaps.map.center.lat(), lng: googleMaps.map.center.lng()};
                        var zoom = googleMaps.map.getZoom();
                        var bounds = googleMaps.map.getBounds();
                        var ne = bounds.getNorthEast();
                        var nePoint = {lat: ne.lat(), lng: ne.lng()};
                        var radius = Utils.calculateMileDistance(centerPoint, nePoint);
                        if (callback) {
                            callback({
                                bounds: bounds,
                                radius: radius,
                                zoom: zoom,
                                center: centerPoint
                            })
                        }
                    }
                });
            },

            clearMarkers: function ()  {
                if (googleMaps.marker) {
                    googleMaps.marker.setMap(null);
                    googleMaps.marker = null;
                }
            },

            clearMarkersCluster: function () {
                if (googleMaps.markerCluster) {
                    googleMaps.markerCluster.clearMarkers();
                }
            },

            placeMarkerAndPanTo: function (latLng, map) {
                if (googleMaps.marker) {
                    googleMaps.marker.setMap(null);
                    googleMaps.marker = null;
                }
                googleMaps.marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                });
                map.panTo(latLng);
                googleMaps.map.setZoom(18);
            },

            placeMarker: function (latLng, map, label) {
                googleMaps.marker = new google.maps.Marker({
                    position: latLng,
                    label:label || '',
                    map: map,
                    icon: googleMaps.markerIcon
                });
            },

            /*
             locations = [
             ['HTML inside markers', 40.724913, -73.939473]
             ]
             */
            addLocations: function (locations, centerLocation) {
                var infoBox;
                for (i = 0; i < locations.length; i++) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                        map: googleMaps.map,
                        icon: googleMaps.markerIcon
                    });
                    var interval = 0;
                    google.maps.event.addListener(marker, 'mouseover', (function (marker, i) {
                        return function () {

                            if(interval){
                              $timeout.cancel(interval);
                            }

                            if(googleMaps.infoBox){
                              googleMaps.infoBox.close();
                              googleMaps.infoBox = undefined;
                            }

                            if( !googleMaps.infoBox ){
                              googleMaps.infoBox = new InfoBox({
                                content: locations[i][0],
                                disableAutoPan: !!centerLocation,
                                maxWidth: 150,
                                pixelOffset: new google.maps.Size(-140, 10),
                                zIndex: null,
                                infoBoxClearance: new google.maps.Size(1, 1),
                              });

                              infoBox = googleMaps.infoBox;
                              googleMaps.infoBox.open(marker.map, this);

                            }

                        }
                    })(marker, i));

                    google.maps.event.addListener(marker, 'mouseout', (function (marker, i) {
                        return function () {
                            interval = $timeout(function () {
                                if (googleMaps.infoBox) {
                                    googleMaps.infoBox.close();
                                    googleMaps.infoBox = undefined;
                                }

                            }, 2000);
                        }
                    })(marker, i));


                }
                googleMaps.mapFitBounds(locations, centerLocation);
            },

            mapFitBounds: function (locations, centerLocation) {
                var bounds = new google.maps.LatLngBounds();

                if (!centerLocation) {
                    for (var i = 0; i < locations.length; i++) {
                        bounds.extend(new google.maps.LatLng(locations[i][1], locations[i][2]));
                    }
                } else {
                    bounds.extend(new google.maps.LatLng(centerLocation[1], centerLocation[2]));
                }

                googleMaps.map.fitBounds(bounds);
            },

            resizeMap: function (w, h) {

                if (!w) {
                    w = $(window).width();
                }
                if (!h) {
                    h = $(window).height();
                }

                $(googleMaps.mapElement).width(w).height(h);
            },

            setMapBounds: function (w, h, locations) {
                if (!w) {
                    w = $(window).width();
                }
                if (!h) {
                    h = $(window).height();
                }

                var direction = localize.isRTL() ? 1 : -1;

                googleMaps.mapFitBounds(locations);

                google.maps.event.addListenerOnce(googleMaps.map, "bounds_changed", function () {
                    googleMaps.map.setZoom(locations.length == 1 ? googleMaps.map.getZoom() - 3 : googleMaps.map.getZoom() - 1);

                    google.maps.event.addListenerOnce(googleMaps.map, "bounds_changed", function () {
                        googleMaps.map.panBy(w * 25 * direction / 100, h * 25 / 100);
                    });
                });

            },

            setFullScreenMap: function (status, locations) {
                googleMaps.fullScreenMap = status;

                if (googleMaps.fullScreenMap) {
                    if (!googleMaps.mapElement) {
                        $log.error("you must specify containerID id");
                    }

                    googleMaps.resizeMap();
                    googleMaps.setMapBounds(null, null, locations);


                    $(window).resize(function () {
                        if (googleMaps.fullScreenMap) {

                            googleMaps.resizeMap();
                            google.maps.event.addListenerOnce(googleMaps.map, "bounds_changed", function () {
                                googleMaps.setMapBounds(null, null, locations);
                            });

                        }
                    });
                }
            },
            /**
             * Get formatted city name string from Google location address components
             *
             * @param location
             * @returns {*}
             */
            getCityName: function(addressComponents) {

            var address = {}, address_array=[];

            // this is kind of heuristic solution depend on which parts of address are available in the response
            for (var i = 0; i <  addressComponents.length; i++) {
                var address_types = addressComponents[i].types;

                if ( address_types.indexOf("neighborhood") > - 1  ) {
                    address.neighborhood = addressComponents[i].long_name? addressComponents[i].long_name: addressComponents[i].short_name;
                    address_array.push(  addressComponents[i].short_name  )
                }


                if ( address_types.indexOf("sublocality") > - 1  ) {
                    address.sublocality = addressComponents[i].short_name? addressComponents[i].short_name: addressComponents[i].long_name;
                    address_array.push( addressComponents[i].short_name  );
                }


                if ( address_types.indexOf("locality") > - 1  ) {
                    address.locality =  addressComponents[i].long_name? addressComponents[i].long_name: addressComponents[i].short_name;
                    address_array.push( addressComponents[i].short_name  );
                }


                if ( address_types.indexOf("administrative_area_level_1") > - 1  ) {
                    address.administrative_area_level_1 =  addressComponents[i].short_name? addressComponents[i].short_name: addressComponents[i].long_name;
                    address_array.push( addressComponents[i].short_name  );
                }
            }

            if( address.neighborhood && address.sublocality  ){
                return address.neighborhood +', '+ address.sublocality ;
            }

            if( address.locality && address.administrative_area_level_1  ){
                return address.locality +', '+ address.administrative_area_level_1 ;
            }

            if( address.sublocality && address.administrative_area_level_1  ){
                return address.sublocality +', '+ address.administrative_area_level_1 ;
            }

            // fallback
            return address_array.join(', ');

        }


        };

        return googleMaps;
    }])

    .directive("fullscreenMap", ["$timeout", "googleMaps", "$q", "hEvent", function ($timeout, googleMaps, $q, hEvent) {
        return {
            restrict: "A",
            scope: {
                locations: "=",
                address: "=",
                refresh: '=',
                events: '=',
                centerLocation: '=',
            },
            link: function (scope, element, attrs) {

                var isMobile = window.matchMedia("only screen and (max-width: 760px)");
                if (!attrs.allowOnMobile && isMobile.matches) {
                    return;
                }

                element.addClass('full-screen-map');

                var locations = [];

                scope.$watch(function(){
                  return scope.refresh;
                },function(newValue){

                  if(!newValue){
                    return;
                  }

                  refreshMap();
                });

                if (angular.isObject(scope.events)) {
                    scope.events.setZoomLevel = function (zoomLevel) {
                        if (googleMaps.map) {
                            googleMaps.map.setZoom(parseFloat(zoomLevel));
                        }
                    }
                }

                function initMap() {
                    var options = {
                        element: element,
                        styles: googleMaps.style['default'],
                        scrollwheel: false,
                        // disableDefaultUI: true,
                        mapTypeControl: false,
                        scaleControl: true,
                    };

                    if (attrs.maxZoom) {
                        options.maxZoom = attrs.maxZoom;
                    }

                    if (attrs.disableUiEvents) {
                        options.draggable = false;
                        options.panControl = false;
                    }

                    googleMaps.initMap(options, function (map, infowindow) {
                        googleMaps.addLocations(locations, scope.centerLocation);

                        if (!attrs.centerMap) {
                            googleMaps.setFullScreenMap(true, locations);
                        }

                        // fix map inappropriate position
                        google.maps.event.trigger(map, 'resize');
                    });
                }

                function refreshMap(){
                  if (!scope.address) {

                    locations = scope.locations;
                    initMap();

                    return;

                  } else {

                    locations = scope.locations;

                    var requests = [];
                    for (var k in locations) {

                        // hEvent.track("geocode", { category: 'google_apis', label: 'refresh_map' });
                      requests.push(googleMaps.locationAutocomplete(locations[k][1]).then(function (location) {
                        if (location[0] && location[0].value) {
                          var location = location[0].value.geometry.location;
                          (function (index, lat, lng) {
                            locations[index][1] = lat;
                            locations[index][2] = lng;
                          })(k, location.lat, location.lng);
                        }
                      }));
                    }
                    $q.all(requests).then(function () {
                      initMap();
                    });

                  }
                }

                refreshMap();

            }
        }
    }]);























